import { first, isEmpty, map } from 'lodash';
import { useState } from 'react';
import { useCompareManagement } from '../../../SideMenuSearchLane/context/compare';
import ComparisonModal from '../ComparisonModal';
import { ComparatorButton, ComparisonLane } from './styles';

const ComparisonLaneComponent = ({ sectionId }) => {
  const { comparisonState, sectionInComparisonMode, onSetSectionInComparisonMode, onCloseSectionInComparisonMode } =
    useCompareManagement();

  const sectionMetadata = comparisonState[sectionId];

  // console.log(comparisonState[sectionId], sectionId);

  const { comparisonCuts } = sectionMetadata;

  const shouldRenderComparisonLane = !isEmpty(comparisonCuts);

  if (!shouldRenderComparisonLane) {
    return null;
  }

  const isComparisonCutAHeader = first(comparisonCuts).isHeader;
  const isModalOpened = sectionInComparisonMode.sectionId === sectionId;
  const className = isComparisonCutAHeader ? 'isHeader' : 'isRegularComparisonCut';

  return (
    <ComparisonLane>
      {map(comparisonCuts, (comparisonCut) => (
        <ComparatorButton
          title='Compare'
          key={comparisonCut.id}
          className={className}
          onClick={() => onSetSectionInComparisonMode(sectionId, comparisonCut.id)}>
          <label className='left-arrow'>⬅</label>
          <label className='right-arrow'>⬅</label>
        </ComparatorButton>
      ))}
      {isModalOpened && <ComparisonModal onModalClose={() => onCloseSectionInComparisonMode()} />}
    </ComparisonLane>
  );
};

export default ComparisonLaneComponent;
